import React, { useState } from "react";
import Header from "../../layouts/Projectpage/Header/Header";
import WelcomeMsg from "../../layouts/Projectpage/Welcomemsg";
import ThemeContext from "../../context";
import ColorsTheme from "../../utils/colors";
import FeedbackTable from "../../layouts/Projectpage/Feedbacktable";

const ProjectPage = () => {
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") !== null
      ? localStorage.getItem("theme")
      : "light"
  );

  const value = { theme, setTheme };
  const colortheme = theme === "light" ? ColorsTheme.light : ColorsTheme.dark;
  document.querySelector("body").style.backgroundColor = colortheme.background;
  return (
    <div
      className="w-full h-full flex items-start justify-center"
      style={{
        background: colortheme.background,
        color: colortheme.color
      }}
    >
      <div className="w-[80%]">
        <ThemeContext.Provider value={value}>
          <Header />
          <WelcomeMsg />
          <FeedbackTable />
        </ThemeContext.Provider>
      </div>
    </div>
  );
};

export default ProjectPage;
